import React from 'react';

const CaracteristicasGeneralesSpc = () => {
  return (
    <section className="p-0 position-relative overflow-visible">
      <div className="container-fluid px-xxl-7">
        <div className="why-choose-style2 bg-dark rounded">
          <div className="row align-items-center align-content-center">
            <div className="col-lg-6 order-2 order-lg-1">
              <div className="mb-4 title-style5">
                <span className="sub-title">Ideal para cocinas, gimnasios y hospitales</span>
                <h2 className="display-5 font-weight-800 text-white mb-0 lh-1">
                Ventajas del Piso SPC
                </h2>
              </div>
              <p className="mb-0 text-white opacity7 w-xl-90 w-xxl-80">
              Gracias a sus numerosas ventajas, el piso SPC es ideal para veterinarias, hospitales y otros entornos que requieren alta resistencia y durabilidad. Es una excelente opción para reemplazar los pisos laminados, ya que cuenta con una manta acolchada que facilita su instalación. Algunas de sus principales ventajas son:
              </p>
            </div>
            <div className="col-lg-6 order-1 order-lg-2 mb-1-9 mb-md-2-5 mb-lg-0">
              <div className="why-choose-img1">
                <img src="/assets/img/productos/pisos-spc/piso-spc-ventajas.jpg" alt="Ventajas Piso SPC" className="rounded" />
              </div>
            </div>
          </div>

          {/* Tarjetas */}
          <div className="row pb-2-5 pb-lg-7 pt-1-9 pt-lg-5 mt-n1-9 border-bottom border-color-light-white-fifty why-choose-dots position-relative">
            <Tarjeta
              imgSrc="/assets/img/icons/icon-67.png"
              titulo="Resistencia al agua"
              descripcion="Es completamente impermeable, lo que permite su instalación en áreas propensas a derrames o humedad, como cocinas, sótanos, baños y gimnasios."
              delay="200ms"
            />
            <Tarjeta
              imgSrc="/assets/img/icons/icon-67.png"
              titulo="Durabilidad "
              descripcion="Ofrece alta resistencia al desgaste y una rigidez excepcional, lo que le otorga a cada lámina una mayor durabilidad con el paso del tiempo."
              delay="400ms"
            />
            <Tarjeta
              imgSrc="/assets/img/icons/icon-67.png"
              titulo="Resistencia al impacto"
              descripcion="Tiene la capacidad de absorber golpes de cualquier agente externo, manteniendo el piso en perfectas condiciones por más tiempo."
              delay="600ms"
            />
            <Tarjeta
              imgSrc="/assets/img/icons/icon-67.png"
              titulo="Propiedades hipoalergénicas"
              descripcion="La superficie vinílica está diseñada para prevenir la proliferación de bacterias y microbios, lo cual es ideal para entornos como hospitales y veterinarias."
              delay="800ms"
            />
          </div>

          {/* Sección final */}
          <div className="row mt-2-0 mt-lg-5 align-items-center position-relative z-index-9">
            <div className="col-lg-8 mb-1-9 mb-lg-0">
              <div className="text-start">
                <h3 className="mb-0 text-white h4">
                Te asesoramos en tu proyecto. ¡Cuéntanos qué superficie deseas cubrir!</h3>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="text-start text-lg-end">
                <a href="contacto-decototal" className="butn-style7 secondary medium rounded">
                Contáctanos ahora
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente para las tarjetas
const Tarjeta = ({ imgSrc, titulo, descripcion, delay }) => {
  return (
    <div className={`col-md-6 col-xl-3 mt-1-9 wow fadeInUp`} data-wow-delay={delay}>
      <div className="card card-style22 border-0 bg-transparent">
        <div className="h-100">
          <div className="card-img">
            <img src={imgSrc} alt="..." className="w-60px" />
          </div>
          <div className="card-title">
            <h3 className="text-white h4">{titulo}</h3>
          </div>
          <p className="mb-0 text-white opacity7">{descripcion}</p>
        </div>
      </div>
    </div>
  );
};

export default CaracteristicasGeneralesSpc;
